import * as $ from 'jquery';
import { BehaviorSubject, Observable } from 'common/barrels/rx';

import { and } from 'common/functions/observable';
import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';

export abstract class ContainerControl extends Control {
    protected activatedSubject = new BehaviorSubject<boolean>(this.defaultActivated());
    activatedStream: Observable<boolean>;

    constructor(args: ControlArgs) {
        super(args);

        this.activatedStream = this.container ? and(this.container.activatedStream, this.activatedSubject) : this.activatedSubject;
    }

    protected propagateEnabledStateToChildElements($container: JQuery, value: boolean) {
        $container.children().toArray().map(x => $(x).data('control')).filter(x => x !== undefined).forEach(x => x.isParentEnabled(value));
    }

    protected defaultActivated() {
        return true;
    }

    abstract resizeStream(): Observable<{}>;
}